const VideoPlayer = ({videoReference, enabled})=>{
    return <div id="vidlayer"><video id="myvid" ref={videoReference} style={{display:!enabled?"none":"block"}} muted autoPlay  /> </div>;
}  


export default VideoPlayer;